import { getToken } from '@/libs/util.token'

export default ({ request }) => ({
  purchaseMaterialListApi(data = {}) {
    return request({
      url: '/factory/purchase/material/list',
      method: 'post',
      data,
    })
  },
  purchaseMaterialDetailApi(data = {}) {
    return request({
      url: '/factory/purchase/material/detail',
      method: 'post',
      data,
    })
  },
  purchaseMaterialAddApi(data = {}) {
    return request({
      url: '/factory/purchase/material/add',
      method: 'post',
      data,
    })
  },
  purchaseMaterialEditApi(data = {}) {
    return request({
      url: '/factory/purchase/material/edit',
      method: 'post',
      data,
    })
  },
  purchaseMaterialDetailListApi(data = {}) {
    return request({
      url: '/factory/purchase/material/detail/list',
      method: 'post',
      data,
    })
  },
  purchaseMaterialDetailDetailApi(data = {}) {
    return request({
      url: '/factory/purchase/material/detail/detail',
      method: 'post',
      data,
    })
  },
  purchaseMaterialDetailAddApi(data = {}) {
    return request({
      url: '/factory/purchase/material/detail/add',
      method: 'post',
      data,
    })
  },
  purchaseMaterialDetailEditApi(data = {}) {
    return request({
      url: '/factory/purchase/material/detail/edit',
      method: 'post',
      data,
    })
  },
  purchaseMaterialDetailDelApi(data = {}) {
    return request({
      url: '/factory/purchase/material/detail/del',
      method: 'post',
      data,
    })
  },
  purchaseMaterialExpenseListApi(data = {}) {
    return request({
      url: '/factory/purchase/material/expense/list',
      method: 'post',
      data,
    })
  },
  purchaseMaterialExpenseDetailApi(data = {}) {
    return request({
      url: '/factory/purchase/material/expense/detail',
      method: 'post',
      data,
    })
  },
  purchaseMaterialExpenseAddApi(data = {}) {
    return request({
      url: '/factory/purchase/material/expense/add',
      method: 'post',
      data,
    })
  },
  purchaseMaterialExpenseEditApi(data = {}) {
    return request({
      url: '/factory/purchase/material/expense/edit',
      method: 'post',
      data,
    })
  },
  purchaseMaterialExpenseDelApi(data = {}) {
    return request({
      url: '/factory/purchase/material/expense/del',
      method: 'post',
      data,
    })
  },
  purchaseMaterialBatchListApi(data = {}) {
    return request({
      url: '/factory/purchase/material/batch/list',
      method: 'post',
      data,
    })
  },
  purchaseMaterialBatchDetailApi(data = {}) {
    return request({
      url: '/factory/purchase/material/batch/detail',
      method: 'post',
      data,
    })
  },
  purchaseMaterialBatchAddApi(data = {}) {
    return request({
      url: '/factory/purchase/material/batch/add',
      method: 'post',
      data,
    })
  },
  purchaseMaterialBatchEditApi(data = {}) {
    return request({
      url: '/factory/purchase/material/batch/edit',
      method: 'post',
      data,
    })
  },
  purchaseMaterialBatchDelApi(data = {}) {
    return request({
      url: '/factory/purchase/material/batch/del',
      method: 'post',
      data,
    })
  },
  purchaseMaterialImportDataApi(data = {}) {
    return request({
      url: '/factory/purchase/material/importData',
      method: 'post',
      data,
    })
  },
  purchaseMaterialDetailChooseListApi(data = {}) {
    return request({
      url: '/factory/purchase/material/detail/choose',
      method: 'post',
      data,
    })
  },
  purchaseMaterialWithExcelBatchImportApi({
    file,
    isSave = false,
    isUpdate = false,
  } = {}) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('isSave', isSave)
    formData.append('isUpdate', isUpdate)

    return request({
      url: '/factory/purchase/material/withExcelBatchImport',
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || '',
      },
      data: formData,
      timeout: 60 * 1000,
    })
  },
})
